import { ReactNode } from "react"

type LoadingFallbackProps = {
  children: ReactNode
  fallback: ReactNode
  hasWaitFor: boolean
}
function LoadingFallback({
  children,
  fallback,
  hasWaitFor,
}: LoadingFallbackProps) {
  if (hasWaitFor) return <>{fallback}</>

  return <>{children}</>
}

export default LoadingFallback
